import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { INumericValue } from '../../interfaces/numeric-value.interface';
import { ITextValue } from '../../interfaces/text-value.interface';
import { Observable } from 'rxjs/Observable';

export class PressureMeasurementServerPlugin extends SmartenitPlugin
  implements INumericValue, ITextValue {
  get stateTTL(): number {
    return 2 * 60;
  }

  public onInit() {
    this.getCache().subscribe((state) => {
      if (state !== undefined) {
        this.state = state;
        this._onUpdate.next({ state });
      }
    });
  }

  public getReportableAttrs() {
    return ['MeasuredValue', 'Tolerance'];
  }

  public getStatus(context?: string, subscribe?: boolean): any {
    context = 'MeasuredValue';
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      context,
      null,
      false,
      `cacheTTL=${this.stateTTL}`
    );
  }

  public setValue(value: number, attribute?: string, subscribe?: boolean): any {
    // Do nothing becase values are read only
    if (subscribe) {
      return Observable.of(true);
    }
    return true;
  }

  public getValue(attribute?: string): number {
    const response: number = Number(this.state);
    return response;
  }

  public getConditionAttribute(): string {
    return 'MeasuredValue';
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public getUnit(attribute?: string): string {
    return 'kPa';
  }

  public getConditionOptions(): any {
    return null;
  }

  public getEffectOptions(): any {
    return null;
  }

  public getTextValue(context?: string) {
    return `${this.state ? String(this.getValue()) : '--'} ${this.getUnit()}`;
  }

  public formatValue(value: string): string {
    return value;
  }

  public getStatusPayload(): any {
    return ['MeasuredValue'];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const response = (message && message.data && message.data.response) || {};
    const attributeOrMethod = message && message.attributeOrMethod;
    const value = response.value;

    if (attributeOrMethod === 'MeasuredValue') {
      const measuredValue = parseInt(value) / 10;
      this.state = Math.round(measuredValue);
      this._onUpdate.next({ state: measuredValue });
    }

    return this.state;
  }

  public getRawValue(
    value: number,
    attribute?: string,
    method?: string
  ): number {
    if (!attribute || attribute === 'MeasuredValue') {
      return this.pluginUtilsService.getValueByMultiplying(value, 10);
    } else {
      return value;
    }
  }

  public getProcessedValue(value: any, attribute?: string, method?: string) {
    if (!attribute || attribute === 'MeasuredValue') {
      return this.pluginUtilsService.getValueByDividing(value, 10);
    } else {
      return value;
    }
  }
}
